class ContrastMode {
	constructor(toggleSelector, labelSelector) {
		this.toggle = document.querySelector(toggleSelector)
		this.label = document.querySelector(labelSelector)
		this.init()
	}

	init() {
		if (!this.toggle) return

		this.contrastMode = localStorage.getItem("contrastMode") === "High"

		this.toggle.checked = this.contrastMode
		this.updateBodyClass()
		this.updateLabel()

		this.toggle.addEventListener("change", () => this.toggleContrastMode())
	}

	toggleContrastMode() {
		this.contrastMode = this.toggle.checked
		this.updateBodyClass()
		this.updateLabel()

		localStorage.setItem("contrastMode", this.contrastMode ? "High" : "Standart")
	}

	updateBodyClass() {
		document.body.classList.toggle("high-contrast-mode", this.contrastMode)
	}

	updateLabel() {
    this.label.textContent = this.contrastMode ? "Standard Contrast" : "High Contrast Mode"
  }
}

document.addEventListener("DOMContentLoaded", () => {
	new ContrastMode("#contrast-toggle", ".contrast-mode-toggle label")
})
